<template>
  <iModal
    v-if="isInviteModalVisible"
    :title="modalTitle"
    :max-width="650"
    :primary-action-button-label="primaryButtonLabel"
    :primary-action-button-loading="isCreatingOffPlatformInvitation"
    :secondary-action-button-label="secondaryButtonLabel"
    @close="closeInviteModal"
    @click:primary="handlePrimaryAction"
  >
    <template #body>
      <InviteCollaboratorForm
        v-if="inviteModalState === 'invite'"
        :form-data="inviteFormData"
        :validation-errors="inviteValidationErrors"
        @update:form-data="updateInviteFormData"
      />
      <ContractProposalForm
        v-if="inviteModalState === 'proposal'"
        :form-data="inviteFormData"
        :validation-errors="inviteValidationErrors"
        @update:form-data="updateInviteFormData"
      />
      <iText v-if="error" variant="error">
        {{ error }}
      </iText>
    </template>
  </iModal>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useCollaboratorStore } from "@/stores/collaborator-store";
import InviteCollaboratorForm from "@/components/publication/InviteCollaboratorForm.vue";
import ContractProposalForm from "@/components/publication/ContractProposalForm.vue";

export default {
  name: "InviteToCollaborateOffPlatform",
  components: {
    InviteCollaboratorForm,
    ContractProposalForm,
  },
  props: {
    publicationId: {
      type: Number,
      required: true,
    },
    orgId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(useCollaboratorStore, [
      "isCreatingOffPlatformInvitation",
      "isInviteModalVisible",
      "inviteModalState",
      "inviteFormData",
      "inviteValidationErrors",
    ]),
    ...mapWritableState(useCollaboratorStore, ["error"]),

    modalTitle() {
      return this.inviteModalState === "invite" ? "Step 1 of 2: Invite Collaborator" : "Step 2 of 2: Collaborator Proposal";
    },
    primaryButtonLabel() {
      return this.inviteModalState === "invite" ? "Propose Contract" : "Send Invite";
    },
    secondaryButtonLabel() {
      return this.inviteModalState === "invite" ? "Cancel" : "Back";
    },
  },
  methods: {
    ...mapActions(useCollaboratorStore, [
      "createOffPlatformInvitation",
      "closeInviteModal",
      "setInviteModalState",
      "updateInviteFormData",
      "validateInviteForm",
      "validateProposalForm",
    ]),

    async handlePrimaryAction() {
      if (this.inviteModalState === "invite") {
        if (this.validateInviteForm()) {
          this.setInviteModalState("proposal");
        }
      } else if (this.inviteModalState === "proposal") {
        if (this.validateProposalForm()) {
          await this.createOffPlatformInvitation(
            this.publicationId,
            this.orgId,
          );
        }
      }
    },
  },
};
</script>
